import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { InfoRequired } from 'pages/EmbeddedCustomers/helpers/types'

export const getInfoRequired = (customerReference: string): Promise<InfoRequired> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `/platform/v1/customers/${customerReference}/info-required`,
    method: 'GET',
  })
}
